import EfCheckInActivities from '@elem/ui/ef-check-in-activities';

export default function ClockIn({ systemTime }: { systemTime?: number }) {
    return <EfCheckInActivities systemTime={systemTime} />;
}
